export default "__VITE_ASSET__b2a69b74__"